import { render } from "./ProjectBudget.vue?vue&type=template&id=6375769b&scoped=true"
import script from "./ProjectBudget.vue?vue&type=script&lang=js"
export * from "./ProjectBudget.vue?vue&type=script&lang=js"

import "./ProjectBudget.vue?vue&type=style&index=0&id=6375769b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6375769b"]])

export default __exports__